(function($){
    $(function(){
        // Customize the range slider styles
        
        function handleCalculatorInputChange(e, input = null) {
            let target = e.target;
        
            if(input !== null){
                target = input;
                const min = target.prop('min');
                const max = target.prop('max');
                const val = target.val();

                target.css('background-size', (val - min) * 100 / (max - min) + '% 100%');
            }else{
                const min = target.min;
                const max = target.max;
                const val = target.value;

                target.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%';
            }
        }

        if($('.calculator-form').length){

            $('.calculator-form input').not('.calculator-form .result input').on('input', function (e){
                if($('.calculator-form .result-wrapper').hasClass('shown')){
                    $('.calculator-form .result-wrapper').removeClass('shown');
                }
            })
            
            $('.calculator-form input[type="range"]').each(input => {
                $(this).on('input', handleCalculatorInputChange);
            });
            
            
            // Local
            // let username = "ck_4754c03b6d79f577f40003dfd06de957e5296d63";
            // let password = "cs_68b294968a74101438aa1f55077aaf7b5dfacf0d";

            // Prod
            // let username = "ck_fdbc32a90922a39b29430eab6d2c4120094168de";
            // let password = "cs_9891744830b05ccbfb4ceadaca6ea5cfcdf974cb";
            // let key = 'Basic '+btoa(`${username}:${password}`);
            $(document).ready(function (e){
                $('.calculator-form').each(function () {
                    let id = $(this).attr('id');
                    $('#'+id+' #custom-button').append('<button type="submit" name="custom-button" class="btn-custom">Calculate</button>');
                    $('#'+id+' #custom-button button').click(function (e){
                        let form_nr = $('#'+id+' input[name="gform_submit"]').val();

                        // console.log(id);
                        // data = $('#'+id).serializeArray();

                        // let prepare_str = '{';
                        // for(i=1; i <= data.length; i++){
                        //     if(data[i]){
                        //         prepare_str+= `"${data[i].name}":"${data[i].value}"${data[i].name != '' && i < data.length - 1 ? ',' : ''}`
                        //     }
                        // }
                        // prepare_str+='}';

                        // data = JSON.parse(prepare_str);
                        
                        // data = JSON.stringify(data);
                        // $.ajax({
                        //     type : "post",
                        //     url: `/wp-json/gf/v2/forms/${form_nr}/submissions`,
                        //     headers: {
                        //         'Authorization': key,
                        //         'Content-Type': 'application/json', 
                        //     },
                        //     data: data,
        
                        //     beforeSend: function(){
                        //     },
        
                        //     success: function(response) {
                        //         console.log(response)
                        //     }    
                        // }); 
                        if(!$('#'+id+' .result-wrapper').hasClass('shown')){
                            $('#'+id+' .result-wrapper').addClass('shown');
                        }
                    })

                    $('#'+id+' .result').wrapAll('<div class="result-wrapper"></div>');
                    $('#'+id+' .current-column').wrapAll('<div class="wrapped-column"></div>');
                    $('#'+id+' .new-column').wrapAll('<div class="wrapped-column"></div>');
                    $('#'+id+' .final-column').wrapAll('<div class="wrapped-column"></div>');
                })
                // $('.calculator-form #custom-button').append('<button type="submit" name="custom-button" class="btn-custom">Calculate</button>');
                
                $('.calculator-form input[type="range"]').each(function (){
                    handleCalculatorInputChange(e, $(this));
                });
            })
        }
    });
})(jQuery);